import React, { useState, useEffect } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetpaasword } from "../../../redux/authslice";

const NewPass = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState({
    new_password: false,
    confirmPassword: false,
  });

  const [input, setInput] = useState({
    new_password: "",
    confirmPassword: "",
    error: "",
  });

  const validatePasswords = () => {
    const { new_password, confirmPassword } = input;

    // Check if passwords match
    if (new_password !== confirmPassword) {
      setInput({ ...input, error: "Passwords do not match." });
      return false;
    }

    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&()_+=|~?/-])(?!.*\\*).{8,}$"
    );
    // Check password strength
    if (!strongRegex.test(new_password)) {
      setInput({
        ...input,
        error:
          "Password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, one digit, and one special character (excluding '*').",
      });
      return false;
    }

    setInput({ ...input, error: "" });
    return true;
  };

  const handleSubmit = () => {
    if (validatePasswords()) {
      dispatch(resetpaasword({ dispatch, navigate, input }));
    }
  };

  useEffect(() => {
    setInput({ ...input, error: "" });
  }, [input.new_password, input.confirmPassword]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  const togglePasswordVisibility = (fieldName) => {
    setShowPassword({ ...showPassword, [fieldName]: !showPassword[fieldName] });
  };

  return (
    <>
      <div className="login-page-2">
        <p className="accout-p">Enter your new password</p>
        <p className="accout-p12">
          Great! The last step is to create and confirm your new password
        </p>
        <div className="mar-15">
          <label className="label1" htmlFor="password">
            Enter password
          </label>
          <input
            className="all-input"
            placeholder="Enter password"
            type={showPassword.password ? "text" : "password"}
            name="new_password"
            value={input.password}
            onChange={handleInputChange}
          />
          <div className="bag-light-2">
            <FontAwesomeIcon
              icon={showPassword.password ? faEyeSlash : faEye}
              onClick={() => togglePasswordVisibility("password")}
            />
          </div>
        </div>
        <div className="mar-15">
          <label className="label1" htmlFor="confirm-password">
            Confirm password
          </label>
          <input
            className="all-input"
            placeholder="Confirm new password"
            type={showPassword.confirmPassword ? "text" : "password"}
            name="confirmPassword"
            value={input.confirmPassword}
            onChange={handleInputChange}
          />
          <div className="bag-light-2">
            <FontAwesomeIcon
              icon={showPassword.confirmPassword ? faEyeSlash : faEye}
              onClick={() => togglePasswordVisibility("confirmPassword")}
            />
          </div>
        </div>
        {input.error && <p className="error_text">{input.error}</p>}
        <div className="mar-15">
          <button className="login-bt" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default NewPass;
